import { get, isEmpty } from 'lodash';
import { setExperimentsBucket } from '@sparefoot/react-core/modules/experiments';

const experimentsMiddleware = (store) => (next) => (action) => {
	const { user } = store.getState();
	const experiments = get(action, 'payload.experiments');
	if (!isEmpty(experiments) && user.visitId !== 'SELENIUM') {
		store.dispatch(setExperimentsBucket(experiments));
	}
	return next(action);
};

export default experimentsMiddleware;
